// Module
var code = "<div class=\"text-search\"> <input class=\"filter-text\" type=\"text\" v-model=\"search\" @input=\"searchChanged()\" :placeholder=\"$t('resource.placeholder.filter')\" ref=\"searchInput\"> </div>";
// Exports
module.exports = code;